import $ from 'jquery';

const dom = {
  $doc: $(document),
  $win: $(window),
  $body: $('body'),
};
export default dom;



// WEBPACK FOOTER //
// ./src/scripts/modules/dom.js